export const GetCountryDetails = () => {
  const _reqHeader = new Headers();
  _reqHeader.append('Content-Type', 'application/json');
  //   _reqHeader.append("Authorization", `Bearer ${token}`);
  const _reqOpts = {
    method: 'GET',
    headers: _reqHeader,
    redirect: 'follow',
  };
  return new Promise((resolve, reject) => {
    fetch(`/data/countryDetails.json`, _reqOpts)
      .then((response) => response.json())
      .then((result) => resolve(result))
      .catch((error) => {
        console.log('error while Country Details =>', error);
        reject(error);
      });
  });
};
